import { NgModule } from '@angular/core';
import { CoreModule } from '../core/core.module';
import { CommonModule } from '../common/common.module';
import { ConsumptionRoutingModule } from './consumption-routing.module';
import { ImdPriceListManagerComponent } from './component/pricelist-manager/pricelist-manager.component';
import { ImdPriceListFormComponent } from './component/pricelist-form/pricelist-form.component';
import { PriceListService } from './service/pricelist.service';
import { PriceListCommandHandlerResolver } from './service/command/pricelist-command-handler-resolver.service';
import { PeriodConsumptionComponent } from './component/period-consumption/period-consumption.component';
import { MeterModelService } from './service/meter-type.service';
import { MeterModelCommandHandlerResolver } from './service/command/meter-model-command-handler-resolver';
import { ImdMeterModelFormComponent } from './component/meter-model-form/meter-model-form.component';
import { ImdMeterModelManagerComponent } from './component/meter-model-manager/meter-model-manager.component';
import { RentalObjectMeterComponent } from './component/rental-object-meter/rental-object-meter.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { CreateMeterDialogFormComponent } from './component/create-meter-dialog-form/create-meter-dialog-form.component';
import { MeterService } from './service/meter.service';
import { ImdImportManagerComponent } from './component/import-manager/imd-import-manager.component';
import { ImdImportAddFormComponent } from './component/import-add-form/import-add-form.component';
import { ImdImportService } from './service/imd-import.service';
import { ImdImportFormComponent } from './component/import-form/import-form.component';
import { ImdImportCommandHandlerResolver } from './service/command/imd-import-command-handler-resolver.service';

@NgModule({
  imports: [CommonModule, CoreModule, ConsumptionRoutingModule, NgApexchartsModule],
  declarations: [
    CreateMeterDialogFormComponent,
    ImdMeterModelFormComponent,
    ImdMeterModelManagerComponent,
    ImdPriceListFormComponent,
    ImdImportFormComponent,
    ImdImportAddFormComponent,
    ImdPriceListManagerComponent,
    ImdImportManagerComponent,
    PeriodConsumptionComponent,
    RentalObjectMeterComponent,
  ],
  providers: [
    MeterModelCommandHandlerResolver,
    MeterModelService,
    MeterService,
    PriceListCommandHandlerResolver,
    PriceListService,
    ImdImportService,
    ImdImportCommandHandlerResolver,
  ],
  exports: [PeriodConsumptionComponent, RentalObjectMeterComponent],
})
export class ConsumptionModule {}
